import axios from 'axios'

export default ({ state, commit, dispatch, rootState }, { file, patientId }) => {
    let authId = rootState.user.user.id

    const currProvider = rootState.provider.id
    return dispatch('get', {
        url: "/provider/" + currProvider + "/upload",
        query: {
            type: file.name.split(".").pop(),
            auth: patientId
        }
    }, {
        root: true
    }).then((response) => {
        let formData = new FormData()
        formData.append('key', response.key)
        formData.append('Policy', response.policy)
        formData.append('X-Amz-Signature', response.signature)
        formData.append('X-Amz-Credential', response.credential)
        formData.append('X-Amz-Algorithm', response.algorithm)
        formData.append('X-Amz-Date', response.date)
        formData.append('acl', response.acl)
        formData.append('X-Amz-Security-Token', response.security)
        formData.append('file', file)
        return axios.post(response.url, formData, {
            withCredentials: false
		}).then((res) => {
            const key = response.key
            return response.url + '/' + key
            // return dispatch('post', {
            //     url: "/provider/" + currProvider + "/import",
            //     data: {
            //         upload: response.url + '/' + key,
            //         provider: providers
            //     }
            // }, {
            //     root: true
            // }).then((result) => {

            //     commit('uploadFileSuccess', result)
            // }).catch(err => {
            //     console.log(err)
            //     commit("uploadFileError", err)
            // })
        }).catch((err) => {
            console.log(err)
        })
    }).catch((err) => {
        console.log(err)
    })
}